import PropTypes from 'prop-types';
import { Skeleton } from 'antd';

export default function CurrentField({ state, label, children }) {
    if (state === 'loading') return <span className="monitoring-current-field" role="status" aria-label={label} aria-busy="true">
        <span aria-hidden="true"><Skeleton.Input active size="small" /></span>
    </span>;
    if (['error', 'retrying'].includes(state)) return <span role="status" title="The sensor request will retry automatically.">Retrying...</span>;
    if (state === 'auth-error') return <span>Sign in again</span>;
    if (['stale', 'refreshing', 'saved'].includes(state)) return <span title="Latest saved readings. The reading timestamp is retained; live updates may still be pending.">{children}</span>;
    return children;
}

CurrentField.propTypes = { state: PropTypes.string, label: PropTypes.string.isRequired, children: PropTypes.node };
